import { db } from "./db";
import { getSyncIndex, getSyncResource } from "./syncApi";
import { saveSyncData } from "./syncStorage";
import { crearCotizacionSync } from "./syncApi";
import {
  listarCotizacionesPendientesOffline,
  construirPayloadCrearCotizacionOffline,
  marcarCotizacionSincronizadaOffline,
  marcarCotizacionErrorSyncOffline,
  marcarCotizacionEnviandoOffline,
} from "./offlineCotizacionService";

const SERVICIOS_OMITIDOS = [];

const SERVICIOS_EXTRA = [
  {
    nombre: "estados",
    endpoint: "/sincronizar/estados",
    min: 0,
  },
  {
    nombre: "validezs",
    endpoint: "/sincronizar/validezs",
    min: 0,
  },
  {
    nombre: "condicionPagos",
    endpoint: "/sincronizar/condicionPago",
    min: 0,
  },
  {
    nombre: "condiciones",
    endpoint: "/sincronizar/condiciones",
    min: 0,
  },
];

function normalizeServices(indexResponse) {
  if (Array.isArray(indexResponse?.servicios)) {
    return indexResponse.servicios;
  }

  if (Array.isArray(indexResponse)) {
    return indexResponse;
  }

  return [];
}

export async function runMorningSync(onProgress) {
  const startedAt = new Date().toISOString();

  await db.sync_meta.put({
    recurso: "GLOBAL",
    estado: "SINCRONIZANDO",
    inicio: startedAt,
    ultimaSync: startedAt,
    ultimoError: null,
  });

  const indexResponse = await getSyncIndex();
  const serviciosIndex = normalizeServices(indexResponse);

  const nombresIndex = new Set(
    serviciosIndex.map((servicio) => servicio.nombre),
  );

  const serviciosExtra = SERVICIOS_EXTRA.filter(
    (servicio) => !nombresIndex.has(servicio.nombre),
  );

  const todosLosServicios = [...serviciosIndex, ...serviciosExtra];

  const serviciosOmitidos = todosLosServicios.filter((servicio) =>
    SERVICIOS_OMITIDOS.includes(servicio.nombre),
  );

  const servicios = todosLosServicios.filter(
    (servicio) => !SERVICIOS_OMITIDOS.includes(servicio.nombre),
  );

  await db.servicios_sync.clear();

  if (servicios.length > 0) {
    await db.servicios_sync.bulkPut(servicios);
  }

  for (const servicio of serviciosOmitidos) {
    await db.sync_meta.put({
      recurso: servicio.nombre,
      estado: "OMITIDO",
      ultimaSync: new Date().toISOString(),
      cantidadRegistros: 0,
      ultimoError: "Servicio omitido temporalmente por problemas en backend",
    });
  }

  let errores = 0;

  for (let i = 0; i < servicios.length; i++) {
    const servicio = servicios[i];

    const nombre = servicio.nombre;
    const endpoint = servicio.endpoint;
    const min = servicio.min;

    onProgress?.({
      actual: i + 1,
      total: servicios.length,
      nombre,
      endpoint,
      estado: "SINCRONIZANDO",
    });

    try {
      const data = await getSyncResource(endpoint, min);
      await saveSyncData(nombre, data);

      onProgress?.({
        actual: i + 1,
        total: servicios.length,
        nombre,
        endpoint,
        estado: "OK",
      });
    } catch (error) {
      errores++;

      await db.sync_meta.put({
        recurso: nombre,
        estado: "ERROR",
        ultimaSync: new Date().toISOString(),
        cantidadRegistros: 0,
        ultimoError: error.message,
      });

      onProgress?.({
        actual: i + 1,
        total: servicios.length,
        nombre,
        endpoint,
        estado: "ERROR",
        error: error.message,
      });
    }
  }

  await db.sync_meta.put({
    recurso: "GLOBAL",
    estado: errores > 0 ? "OK_CON_ERRORES" : "OK",
    ultimaSync: new Date().toISOString(),
    fin: new Date().toISOString(),
    totalServicios: servicios.length,
    totalOmitidos: serviciosOmitidos.length,
    totalErrores: errores,
    ultimoError:
      errores > 0
        ? `${errores} servicio(s) con error`
        : serviciosOmitidos.length > 0
        ? `${serviciosOmitidos.length} servicio(s) omitido(s)`
        : null,
  });

  return servicios.length;
}

export async function getSyncStatus() {
  return db.sync_meta.toArray();
}

export async function syncCotizacionesPendientes(onProgress) {
  const pendientes = await listarCotizacionesPendientesOffline();

  let ok = 0;
  let errores = 0;

  for (const cotizacion of pendientes) {
    try {
      const payload = await construirPayloadCrearCotizacionOffline(
        cotizacion.idLocal,
      );

      if (!payload.detalles || payload.detalles.length === 0) {
        throw new Error(
          "La cotización no tiene detalles válidos para sincronizar",
        );
      }

      await marcarCotizacionEnviandoOffline(cotizacion.idLocal, payload);

      onProgress?.({
        tipo: "COTIZACION",
        nombre: cotizacion.folioLocal,
        estado: "ENVIANDO",
      });

      const respuesta = await crearCotizacionSync(payload);

      await marcarCotizacionSincronizadaOffline(cotizacion.idLocal, respuesta);

      ok++;

      onProgress?.({
        tipo: "COTIZACION",
        nombre: cotizacion.folioLocal,
        estado: "SINCRONIZADA",
        respuesta,
      });
    } catch (error) {
      errores++;

      await marcarCotizacionErrorSyncOffline(cotizacion.idLocal, error);

      onProgress?.({
        tipo: "COTIZACION",
        nombre: cotizacion.folioLocal,
        estado: "ERROR",
        error: error.message,
      });
    }
  }

  return { total: pendientes.length, ok, errores };
}
